// Function to get Lat/Lng from a Zip Code using Nominatim
function geocodeZipCode(zipCode) {
    var url = 'https://nominatim.openstreetmap.org/search?format=json&postalcode=' + zipCode + '&countrycodes=us&limit=1';
    
    return fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data && data.length > 0) {
                return { 
                    lat: parseFloat(data[0].lat), 
                    lng: parseFloat(data[0].lon) 
                };
            }
            throw new Error("Could not find coordinates for that zip code.");
        });
}

// Haversine Formula to calculate distance in miles between two coordinates
function getDistance(lat1, lon1, lat2, lon2) {
    const R = 3958.8; // Radius of the Earth in miles
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
            
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in miles

    return distance;
}

// Validating Zip Code field
const validateZip = (zipCode) => {
    const regex = /^[0-9]{5}$/;
    if (zipCode.match(regex)) {
        return true;
    } else {
        return false;
    }
}

const zipSearch = async (zipForm) => {
    zipForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        const zipField = zipForm.querySelector(".menu-locations__zip");
        const zipFieldValue = zipField.value;
        const zipFieldError = document.querySelector('.menu-locations__zip--error');

        if (!validateZip(zipFieldValue)) {
            zipFieldError.classList.add("error-active");
            return;
        } else {
            zipFieldError.classList.remove("error-active");
        }

        const userLatLng = await geocodeZipCode(zipFieldValue);
        const allLocations = Array.from(document.querySelectorAll('.menu-locations__location'));
        const locationList = document.querySelector('.menu-locations__locations');
        let distanceArray = [];
        allLocations.forEach(loc => {
            const locLat = loc.dataset.lat;
            const locLng = loc.dataset.lng;
            const distanceTo = getDistance(userLatLng.lat, userLatLng.lng, locLat, locLng).toFixed(1);
            const locMiles = loc.querySelector(".menu-locations__location--button-container");
            const locMilesContainer = locMiles.querySelector(".menu-locations__location--miles");

            if (locMilesContainer) {
                locMilesContainer.textContent = `${distanceTo} miles away`;
            } else {
                locMiles.insertAdjacentHTML('beforeend', `<div class='menu-locations__location--miles'>${distanceTo} miles away</div>`);
            }

            const locationObject = {
                el: loc,
                distance: distanceTo
            };
            distanceArray.push(locationObject);
        })
        distanceArray.sort((a, b) => a.distance - b.distance);
        locationList.innerHTML = "";
        distanceArray.forEach((loc, index) => {
            if (loc.el.classList.contains('location-active')) {
                loc.el.classList.remove('location-active');
            }

            if (index === 0) {
                loc.el.classList.add('location-active');
            }

            locationList.insertAdjacentElement('beforeend', loc.el);
        })
    })
}

export { zipSearch }